import Service from './Service';

class AdvogadoSustentacaoOralService extends Service {
    handleResponse(response) {
        if (response.status >= 200 && response.status <= 299) {
            return true;
        } else {
            console.error(response.status, ':', response.message);
            return response.message;
        }
    }

    handleDataResponse(response) {
        if (response.status >= 200 && response.status <= 299) {
            return {
                success: true,
                data: response.data,
                response: response
            };
        } else {
            console.error(response.status, ':', response.message);
            return response.message;
        }
    }

    async excluirSustentacaoOral(sessaoId, numeroProcesso, oab, codigoParte) {
        const response = await this.getAdvogadoSustentacaoOralApi().excluirSustentacaoOral(
            sessaoId,
            numeroProcesso,
            oab,
            codigoParte
        );
        return this.handleResponse(response);
    }

    static tratarParametroObrigatorioAdvogado(advogado) {
        if (!advogado) {
            throw new TypeError(`Parâmetro obrigatório (\`advogado\`) não informado. Esperado \`Object\`.`);
        }

        if (!advogado.regOAB) {
            throw new TypeError(
                `Parâmetro obrigatório incompleto. O atributo \`regOAB\` do objeto \`advogado\` não pode ser nulo.${advogado.nome ? ` (adv: ${advogado.nome})` : ''}`
            );
        }

        if (!advogado.regOAB.numero) {
            throw new TypeError(
                `Parâmetro obrigatório incompleto. O atributo \`regOAB.numero\` do objeto \`advogado\` não pode ser nulo.${advogado.nome ? ` (adv: ${advogado.nome})` : ''}`
            );
        }

        if (!advogado.regOAB.siglaUf) {
            throw new TypeError(
                `Parâmetro obrigatório incompleto. O atributo \`regOAB.siglaUf\` do objeto \`advogado\` não pode ser nulo.${advogado.nome ? ` (adv: ${advogado.nome})` : ''}`
            );
        }

        if (!advogado.nome) {
            let oab = '';

            if (advogado.regOAB.letra) {
                oab = `${advogado.regOAB.numero}-${advogado.regOAB.letra}/${advogado.regOAB.siglaUf}`;
            } else {
                oab = `${advogado.regOAB.numero}/${advogado.regOAB.siglaUf}`;
            }

            throw new TypeError(
                `Parâmetro obrigatório incompleto. O atributo \`nome\` do objeto \`advogado\` não pode ser nulo. (OAB: ${oab})`
            );
        }
    }

    async incluirSustentacaoOral(sessaoId, numeroProcesso, advogado, parte, sequencialPreferencia, documentos) {
        AdvogadoSustentacaoOralService.tratarParametroObrigatorioAdvogado(advogado);

        const oab = {
            numero: parseInt(advogado.regOAB.numero, 10),
            letra: advogado.regOAB.letra ? advogado.regOAB.letra : '',
            siglaUf: advogado.regOAB.siglaUf
        };

        const novoAdvogado = {
            nome: advogado.nome,
            genero: advogado.genero,
            regOAB: oab,
            presente: advogado.presente,
            modoParticipacao: advogado.modoParticipacao,
            dataSolicitacaoSustentacao: advogado.dataSolicitacaoSustentacao,
            sequencialDigitacao: advogado.sequencialDigitacao
        };

        const response = await this.getAdvogadoSustentacaoOralApi().incluirSustentacaoOral(
            sessaoId,
            numeroProcesso,
            parte,
            sequencialPreferencia,
            novoAdvogado,
            documentos
        );
        return this.handleResponse(response);
    }

    async alterarSustentacaoOral(sessaoId, numeroProcesso, oldAdvogado, parte, newAdvogado, documentos, sequencialPreferencia) {
        const letra = oldAdvogado.regOAB.letra ? `-${oldAdvogado.regOAB.letra}` : '';
        const oab = `${oldAdvogado.regOAB.numero}-${oldAdvogado.regOAB.siglaUf}${letra}`;
        const response = await this.getAdvogadoSustentacaoOralApi().alterarSustentacaoOral(
            sessaoId,
            numeroProcesso,
            oab,
            parte,
            newAdvogado,
            documentos,
            sequencialPreferencia
        );
        return this.handleResponse(response);
    }

    async corrigirDadosAdvogado(sessaoId, numeroProcesso, oldAdvogado, parte, newAdvogado) {
        const letra = oldAdvogado.regOAB.letra ? `-${oldAdvogado.regOAB.letra}` : '';
        const oab = `${oldAdvogado.regOAB.numero}-${oldAdvogado.regOAB.siglaUf}${letra}`;
        const response = await this.getAdvogadoSustentacaoOralApi().corrigirDadosAdvogado(
            sessaoId,
            numeroProcesso,
            oab,
            parte,
            newAdvogado
        );
        return this.handleResponse(response);
    }

    async consultarAdvogados(nome, numeroOab, siglaUfOab, letraOab, contem) {
        if (!nome && !numeroOab && !siglaUfOab) {
            return this.handleDataResponse({
                status: 400,
                message: 'Informe ao menos um dos campos de busca'
            });
        }

        const response = await this.getAdvogadoSustentacaoOralApi().consultarAdvogados(
            nome,
            numeroOab,
            siglaUfOab,
            letraOab,
            contem
        );
        return this.handleDataResponse(response);
    }

    async notificarAlteracaoAdvogado(idSessao, numeroProcesso, clienteEnvelopeId) {
        await this.getSessaoApi().notificarAlterarProcesso(idSessao, numeroProcesso, clienteEnvelopeId);
    }

    async listarDocumentos(inscricaoId) {
        const response = await this.getAdvogadoSustentacaoOralApi().listarDocumentos(inscricaoId);
        return response;
    }

    async uploadDocumento(file, onProgress) {
        const response = await this.getAdvogadoSustentacaoOralApi().uploadDocumento(file, onProgress);
        return response.data;
    }

    async uploadDocumentoParaInscricao(sessaoId, numeroProcesso, representanteId, codigoParte, file, onProgress) {
        const response = await this.getAdvogadoSustentacaoOralApi().uploadDocumentoParaInscricao(
            sessaoId,
            numeroProcesso,
            representanteId,
            codigoParte,
            file,
            onProgress
        );
        return response.data;
    }

    async removerDocumento(arquivoId) {
        await this.getAdvogadoSustentacaoOralApi().removerDocumento(arquivoId);
    }

    async alterarEstadoInscricao(inscricaoId, codEstado) {
        const response = await this.getAdvogadoSustentacaoOralApi().alterarEstadoInscricao(inscricaoId, codEstado);
        return this.handleResponse(response);
    }

    async alterarPresencaInscricao(inscricaoId, presenca) {
        const response = await this.getAdvogadoSustentacaoOralApi().alterarPresencaInscricao(inscricaoId, presenca);
        return this.handleResponse(response);
    }

    async alterarModoParticipacaoInscricao(inscricaoId, modoParticipacao) {
        const response = await this.getAdvogadoSustentacaoOralApi().alterarModoParticipacaoInscricao(
            inscricaoId,
            modoParticipacao
        );
        return this.handleResponse(response);
    }
}

export default AdvogadoSustentacaoOralService;
